import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvService {

  public serverUrl = '';
  public allowSocialLogin = false;
  public socialLogin = {};
  public app: string;
  public domain: string;
  public excludeDomainUrl: any[];
  public firstPage: string;
  public creditEnabled: boolean;
  public encryptionIV: string;
  public socketEnabled: boolean;
  public isVM: boolean;

  constructor() {
  }
}
